import AdyenCheckout from '@adyen/adyen-web';
import AdyenCore from '@adyen/adyen-web/dist/types/core';
import { CoreOptions } from '@adyen/adyen-web/dist/types/core/types';
import { Env } from '../context';
import { CurrentLocale, translationsMap } from './localisation';

export enum SdkType {
  ENROLLMENT,
  FSCP,
}

export default function prepAdyenSdk(env: Env, type: SdkType): () => Promise<AdyenCore> {
  const configuration: CoreOptions = {
    locale: CurrentLocale, // The shopper's locale. For a list of supported locales, see https://docs.adyen.com/checkout/components-web/localization-components.
    environment: env === Env.PROD ? 'live' : 'test', // When you're ready to accept live payments, change the value to one of our live environments https://docs.adyen.com/checkout/components-web#testing-your-integration.
    clientKey: getKey(env, type),
    // full overview of fields at https://github.com/Adyen/adyen-web/blob/master/packages/lib/src/language/locales/en-US.json
    translations: translationsMap,
  };

  return () => AdyenCheckout(configuration);
}

function getKey(env: Env, type: SdkType): string | undefined {
  if (env === Env.PROD) {
    if (type === SdkType.ENROLLMENT) {
      return 'live_P74OUALH5RDOJABTDBBKWOPXJQTMAMOW'; // enrollment prod
    }
    if (type === SdkType.FSCP) {
      return 'live_P5DCP76WTVHA7NJMIQYCJG2WVAKJ4MCE'; // FSCP prod
    }
  }
  return 'test_DOE4GFLYQRGVBDOVFHVYJT6YPYIHYKCZ'; // general test key
}
